module.exports = __webpack_public_path__ + "static/media/options.a22c4af1.svg";